<div class="container-inco">
  <div class="action-bar">
    <div class="action-buttons-left"></div>
    <div class="action-buttons-right">
      @if (verificationStatus === 'error') {
        <a class='kpi-button-menu'
          title="Toggle visibility of correct rows"
          (click)="toggleShowOnlyErrors()"
          >
          <span class='glyphicon glyphicon-filter'></span> {{ showOnlyErrors ? 'All' : 'Errors' }}
        </a>
      }
      @if (validationMeasures.length > 0 || showColumnFilters) {
        <a class='kpi-button-menu'
          [class.active]="showColumnFilters"
          [title]="showColumnFilters ? 'Remove filters and show all rows' : 'Filter by BU, Management ID or Name'"
          (click)="showColumnFilters = !showColumnFilters"
          >
          <span class='glyphicon glyphicon-filter'></span> Filter
        </a>
      }
      @if (validationMeasures.length > 0) {
        <a class='kpi-button-menu'
          title="Verify values with SAP"
          (click)="onClickVerify()"
          >
          <span class='glyphicon glyphicon-ok-circle'></span> Validate
        </a>
      }
    </div>
  </div>
  <div class="table-act-container">
    <app-data-table
      [columns]="tableColumns"
      [data]="displayedMeasures"
      [showColumnFilters]="showColumnFilters"
      [loading]="isLoading"
      [hasTotalRow]="false"
      [alternateRowColors]="true"
      [highlightOnHover]="true"
      [emptyMessage]="'No data found'"
      [loadingMessage]="'Loading projects...'">
    </app-data-table>
  </div>
</div>
